'use client'

import { useEffect } from 'react'
import Errors from '@/components/content/fallback/Errors'
import { createLogger } from '@/lib/logger'

const logger = createLogger('ErrorBoundary')

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    logger.error(error)
  }, [error])

  return <Errors title="500" message="Something went wrong. Please try again later." theme="dark" />
}
